module.exports = [{"id":1,"size":5,"name":5,"prices":[{"id":1,"price":170},{"id":3,"price":190.8}]},{"id":2,"size":20,"name":20,"prices":[{"id":1,"price":558},{"id":3,"price":630}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/pretreatment.json
// module id = 175
// module chunks = 0